import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const getNestedValue = (obj, path) => {
  if (!path || typeof path !== "string") return "NA";
  const value = path.split(".").reduce((acc, key) => {
    return acc && acc[key] !== undefined ? acc[key] : null;
  }, obj);

  if (value === null || value === undefined) return "NA";

  if (typeof value === "boolean") {
    return value ? "True" : "False"; 
  }
  return value;
};
/**
 * @param {Array} data 
 * @param {Array} columns 
 * @param {String} fileName 
 */
export const exportToExcel = (data, columns, fileName = "data.xlsx") => {
  if (!data || data.length === 0) {
    console.warn("⚠️ No data to export");
    return;
  }

  if (!columns || columns.length === 0) {
    console.warn("⚠️ No columns defined");
    return;
  }


  const filteredData = data.map((item) => {
    let row = {};
    columns.forEach((col) => {
      const header =
        col.header && typeof col.header === "string" ? col.header : "Column";
      row[header] = getNestedValue(item, col.key); // null → "NA"
    });
    return row;
  });
  

  const worksheet = XLSX.utils.json_to_sheet(filteredData);

  const colWidths = columns.map((col) => {
    const header =
      col.header && typeof col.header === "string" ? col.header : "Column";

    const headerLength = header.length;
    const maxLength = Math.max(
      headerLength,
      ...filteredData.map((row) =>
        row[header] !== undefined && row[header] !== null
          ? String(row[header]).length
          : 2 
      )
    );

    return { wch: maxLength + 2 };
  });
  worksheet["!cols"] = colWidths;

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, fileName);

  console.log(`✅ Excel exported: ${fileName}`);
};
